<template>
  <div>
    <b-overlay center :show="isLoading" rounded="sm">
      <div v-if="!isLoading">
        <export-options
          :exportUrl="exportUrl"
          :repository="repository"
          :resource="resource"
          :tableRef="$refs[tableRef]"
          :filter="filter"
          :options="[
        {
          code: 'REGIFOCA',
          label: null,
          formats: ['csv', 'pdf'],
        },
      ]"
        ></export-options>
        <book-entries
          :isTableInModal="true"
          :fields="fields"
          :repository="repository"
          :resource="resource"
          :filterName="filterName"
          :ref="tableRef"
          :hasChecksButtonGroup="false"
          :filterOn="{
            byRelations: [
              'byBroker',
              'byTask',
              'byInsurer',
              'byInsuranceAncillary',
              'byVariousAccounting',
              'byInsurerAccounting',
            ],
          }"
          :onlyActions="['infomodal', 'edit_broker']"
          noInnerWidth
          sortField="book_date"
          noInputPaginator
          noPagination
          includeBottomRow
          @edit="onEdit"
        ></book-entries>
      </div>

      <template #overlay>
        <div class="text-center">
          <base-icon name="loading" width="35" height="35"/>
          <p id="cancel-label">Operazione in corso...</p>
        </div>
      </template>
    </b-overlay>
  </div>
</template>

<script>
import BaseIcon from "@/components/BaseIcon";
import BookEntries from "@/components/tables/BookEntries";
import {toLocaleCurrency} from "@/utils/strings";
import {toLocaleDate} from "@/utils/dates";
import DetailTabAutofetchTableMixin from "@/mixins/DetailTabAutofetchTableMixin";
import ExportOptions from "@/components/ExportOptions";

export default {
  mixins: [DetailTabAutofetchTableMixin],
  components: {
    ExportOptions,
    BaseIcon,
    BookEntries,
  },
  name: "Takings",
  props: {
    resourceId: Number,
  },
  data() {
    return {
      exportUrl: null,
      filter: this.initFilter(),
      filterName: "filterBookEntriesByRegistry",
      resource: "book_entries",
      repository: "book_entry",
      tableRef: "BookEntriesByRegistryTableRef",
      items: [],
      fields: [
        {
          key: "book_date",
          label: this.getDictionary("book_date", "book_entry"),
          sortable: true,
          sortKey: "book_date",
          formatter: (value) => toLocaleDate(value),
        },
        {
          key: "effective_date",
          label: this.getDictionary("effective_date", "book_entry"),
          sortable: true,
          sortKey: "effective_date",
          formatter: (value) => toLocaleDate(value),
        },
        {
          key: "insurer.formatted_title",
          label: this.getDictionary("insurer_id", "book_entry"),
        },
        {
          key: "insurance_policy_number",
          label: this.getDictionary("insurance_policy_number", "book_entry"),
        },
        {
          key: "branch",
          label: this.getDictionary("title", "risk_branch"),
          sortable: false,
        },
        {
          key: "prodotto_incassi",
          label: this.getDictionary("insurance_risk"),
          sortable: false,
        },
        {
          key: "document_code",
          label: this.getDictionary("code", "book_tag"),
        },
        {
          key: "customer",
          label: this.getDictionary("registry"),
          sortable: false,
        },
        {
          key: "gross",
          label: this.getDictionary("gross", "book_entry"),
          sortable: true,
          sortKey: "gross",
          formatter: (value) => toLocaleCurrency(value),
          thClass: "text-right",
          thStyle: {
            "text-align": "right",
          },
          tdClass: "text-right",
        },
        {
          key: "agency_gross",
          label: this.getDictionary("Provv. Agenzia"),
          sortable: false,
          thClass: "text-right",
          thStyle: {
            "text-align": "right",
          },
          tdClass: "text-right",
        },
        {
          key: "saler_gross",
          label: this.getDictionary("Provv. Produttore"),
          sortable: false,
          thClass: "text-right",
          thStyle: {
            "text-align": "right",
          },
          tdClass: "text-right",
        },
        {
          key: "broker",
          label: this.getDictionary("broker", "book_entry"),
        },
        {
          key: "deferred",
          label: this.getDictionary("Sospeso"),
          tdClass: "text-center",
        },
      ],
    };
  },
  methods: {
    initFilter() {
      let init = {
        byView: "book_entry",
        byRegistry: {id: this.resourceId},
      };
      return init;
    },
    onSearch(name) {
      let criteria = this.filter;
      this.saveFilterByName({name, criteria});
      this.exportUrl = this.$refs[this.tableRef].loadFilter(
        this.$refs[this.tableRef].filterName
      );
    },
    onEdit(item, onlyEditBroker = false) {
      this.$router.push({
        name: `${this.resource}.edit`,
        params: {
          id: `${item.id}`,
          item: item,
          mode: "I",
          type: "edit",
          onlyEditBroker: onlyEditBroker,
        },
      });
    },
  },
  component: {
    BookEntries,
    ExportOptions,
  },
  beforeMount() {
    this.saveFilterByName({name: this.filterName, criteria: this.filter});
  },
  mounted() {
    this.onSearch(this.filterName);
  },
};
</script>
